import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { FiscalYearGetter } from '@/store/fiscalYear/fiscalYear.module';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { ProvinceGetter } from '@/store/province/province.module';
import { Province } from '@/store/province/province.model';
import ProvinceFilterComponent from '@/components/provinceFilter/ProvinceFilter.vue';
import ProjectProvinceSummaryComponent from '@/components/project/main/projectProvinceSummary/ProjectProvinceSummary.vue';
import ResultResponseComponent from '@/components/resultResponse/ResultResponse.vue';
import ResultProjectTypeComponent from '@/components/resultProjectType/ResultProjectType.vue';

export default defineComponent({
  name: 'ResultProvincePage',
  components: {
    ProvinceFilterComponent,
    ProjectProvinceSummaryComponent,
    ResultResponseComponent,
    ResultProjectTypeComponent,
  },
  setup: () => {
    const store = useStore();
    const fiscalYear = computed<FiscalYear>(() => store.getters[FiscalYearGetter.BY_ID](fiscalYearId.value));
    const province = computed<Province>(() => store.getters[ProvinceGetter.BY_ID](provinceId.value));
    const fiscalYearId = ref<number | null>();
    const provinceId = ref<number | null>();

    const filterChange = (filter: { fiscalYearId: number; provinceId: number }) => {
      fiscalYearId.value = filter.fiscalYearId;
      provinceId.value = filter.provinceId;
    };

    return {
      fiscalYear,
      province,
      filterChange,
    };
  }
});
